export { default } from './CurrentWindMap';
